
import { defineComponent, ref, watch } from 'vue';
import { useList } from '@/hooks/use-list';
import usePermissionConfig from './use-permission-config';
import { DELIVERY_TYPE_LIST, EMERGENCY_LEVEL_LIST } from '@/constant/production-demand';
import { getOrderList } from '@/api/production-demand';
import { IProductionOrderListListItem, IProductionOrderListReq } from '@/api/production-demand/type';
import { useDictionary } from '@/hooks/use-dict';
import Logger from '../components/logger/main.vue';

export default defineComponent({
  components: { Logger },
  setup() {
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IProductionOrderListListItem, IProductionOrderListReq>({
      request: {
        api: getOrderList,
        params: {
          styleCodeLike: '',
          orderCodeLike: '',
          pageNum: 1,
          pageSize: 20,
        },
      },
    });

    // 接单主体
    const { batchDictListMap } = useDictionary(['pims_receiving_entity']);
    watch([
      () => batchDictListMap.value.pims_receiving_entity,
      () => tableData.value,
    ], ([entity, list]) => {
      if (entity?.length && list?.length) {
        console.log('watch', entity, list);
        list.forEach((item) => {
          item.orderMainstayName = entity.find(it => it.valueCode === item.orderMainstay)?.value ?? '';
        });
      }
    });

    handleSearch();

    // ref
    const orderLogRef = ref();
    const loggerVisible = ref(false);
    const handleLog = (row: IProductionOrderListListItem) => {
      orderLogRef.value.show(row.orderId);
      loggerVisible.value = true;
    };

    return {
      permissionConfig: usePermissionConfig(),
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      handleLog,

      EMERGENCY_LEVEL_LIST,
      DELIVERY_TYPE_LIST,

      orderLogRef,
      loggerVisible,
    };
  },
});
